// extracted by mini-css-extract-plugin
export default {"title":"AccessDenied_title__PvG5I"};